/*
 * This model holds the data for curriculum api access page of the calcualtor
 *
 */
import httpClient from 'client/js/models/http-client'

class Fees {
   static async getFeeCode(studentType, feeType, commencementYear, courseType) {
      try {
         const payload = {
            studentType,
            feeType,
            commencementYear,
            courseType
         };
         let response = await httpClient.post(BaseURL + "/api/fees/code/", payload)
         return response.data || payload
      } catch (err) {
         let response = err.response
         if (response && response.data.response)
            throw new Error(response.data.response)
         throw (err)
      };
   }

   static async getFees(studentTypeCode) {
      try {
         const payload = {
            code: studentTypeCode
         };

         let response = await httpClient.post(BaseURL + "/api/fees/details/", payload)
         return response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response)
            throw new Error(response.data.response)
         throw (err)
      };
   }

   static async getPotentialStudentTypes(studentType, feeType, courseType) {
      try {
         const payload = {
            studentType,
            feeType,
            courseType
         };
         let response = await httpClient.post(BaseURL + "/api/fees/getPotentialStudentTypes/", payload)
         return response.data || payload
      } catch (err) {
         let response = err.response
         if (response && response.data.response)
            throw new Error(response.data.response)
         throw (err)
      };
   }
}

module.exports = Fees
